import { track } from "../track";

export const trackCreatePhotoUploadFail = (params: { error: string }) =>
  track({ event: "create_photo_upload_fail", ...params });
